import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { PropTypes } from 'prop-types';
import { reset, change } from 'redux-form';
import { push } from 'connected-react-router';
import moment from 'moment';
import NotFoundPage from 'components/Errors/NotFoundPage';
import AccessControl from 'components/AccessControl';
import ActivityPerms from 'components/AccessControl/permissions.json';

import {
  accountDataLoad,
  accountCustomerLink,
  accountCustomerUnlink,
  accountFormUnlink,
  showAccountNumberChangeModal,
  hideAccountNumberChangeModal,
  processAccountNumberChange,
  showUnlinkFormModal,
  hideUnlinkFormModal,
  clearAccountData,
  getParentImyForms,
  showDeleteFormModal,
  hideDeleteFormModal,
  deleteForms,
  takeQueueItem,
  hideOwnershipModal,
  showUpdateDualFormStatusModal,
  hideUpdateDualFormStatusModal,
  updateDualFormStatus,
  editAccountName,
  cancelEditAccountName,
  updateAccountName,
  editAccountType,
  cancelEditAccountType,
  updateAccountType,
  editAccountDueDiligence,
  cancelEditAccountDueDiligence,
  updateAccountDueDiligence,
  editAccountCpEquityInterest,
  cancelEditAccountCpEquityInterest,
  updateAccountCpEquityInterest,
  getAllControllingPersons,
  expireControllingPerson,
  removeControllingPerson,
  getRc518CpForms,
  hideLinkToImyStructureConfirmModal,
  showLinkToImyStructureConfirmModal,
  linkAccountToImyStructure,
  getAccountLinkedImyStructure,
  clearAccountLinkedImyStructure
} from 'actions';

import getCertifictionStatus from 'common/Forms/CertificationStatus';
import AccountNumberChangeModal from 'components/Modals/AccountNumberChangeModal';
import LoadingWrapper from 'components/Common/LoadingWrapper';
import AddAccountCustomerForm from 'components/Account/AddAccountCustomerForm';
import AccountCustomerList from 'components/Account/AccountCustomerList';
import AccountFormList from 'components/Account/AccountFormList';
import ConfirmModal from 'components/Modals/ConfirmModal';
import DeleteFormModal from 'components/Modals/DeleteFormModal';
import ChangeOwnershipModal from 'components/Modals/ChangeOwnershipModal';
import UpdateDualFormStatusModal from 'components/Modals/UpdateDualFormStatusModal';
import ActiveChip from 'components/Common/ActiveChip';
import withContainerErrorBoundary from 'components/ErrorBoundaries/ContainerErrorBoundary/withContainerErrorBoundary';
import WithholdingRates from 'components/WithholdingRates';
import MoveForm from 'components/MoveForm';
import CloneForm from 'components/CloneForm';
import DirectChip from 'components/Common/DirectChip';
import AccountComments from 'components/Account/AccountComments';
import AccountControllingPersonsList from 'components/Account/AccountControllingPersonsList';
import AddAccountControllingPerson from 'components/Account/AddAccountControllingPerson';
import ControllingPersonUnlinkModal from 'components/Modals/ControllingPersonUnlinkModal';
import LinkedImyStructure from 'components/LinkedImyStructure';
import UnlinkedImyStructure from 'components/UnlinkedImyStructure';
import LinkWhsAccountModal from 'components/Modals/LinkWhsAccountModal';
import FinancialAccountTypes from 'common/Accounts/FinancialAccountTypes';
import DueDiligenceProcedures from 'common/Accounts/DueDiligenceProcedures';

class Account extends Component {
  static propTypes = {
    permissions: PropTypes.arrayOf(PropTypes.string),
    settings: PropTypes.shape({
      showWithholding: PropTypes.bool,
      showJointAccounts: PropTypes.bool,
      showDualForms: PropTypes.bool
    }).isRequired,
    dispatch: PropTypes.func.isRequired,
    storeAccount: PropTypes.shape(),
    isLoadingData: PropTypes.bool.isRequired,
    match: PropTypes.shape({
      params: PropTypes.shape({
        id: PropTypes.string.isRequired
      }).isRequired
    }).isRequired,
    isAccountNumberChangeModalShown: PropTypes.bool.isRequired,
    accountDataLoadError: PropTypes.shape({
      code: PropTypes.number,
      message: PropTypes.string
    }),
    linkedImyStructure: PropTypes.shape(),
    isDeleteFormModalShown: PropTypes.bool,
    isDeletingForm: PropTypes.bool,
    deleteFormError: PropTypes.string,
    isUnlinkFormModalShown: PropTypes.bool,
    isUnlinkingForm: PropTypes.bool,
    unlinkFormError: PropTypes.string,
    isOwnershipModalShown: PropTypes.bool,
    changeOwnershipItem: PropTypes.shape(),
    defaultWhdCustomerId: PropTypes.number,
    isUpdateDualFormStatusModalShown: PropTypes.bool,
    isUpdatingDualFormStatus: PropTypes.bool,
    updateDualFormStatusError: PropTypes.string,
    dualFormCheckStatus: PropTypes.bool,
    dualFormSelectedAccountId: PropTypes.number,
    dualFormSeletedAccountNumber: PropTypes.string,
    isEditingAccountName: PropTypes.bool,
    isEditingAccountType: PropTypes.bool,
    isEditingAccountDueDiligence: PropTypes.bool,
    isEditingAccountCpEquityInterest: PropTypes.bool,
    isSubmittingAccount: PropTypes.bool,
    controllingPersons: PropTypes.arrayOf(PropTypes.shape()),
    isGettingControllingPersons: PropTypes.bool,
    isExpiringControllingPerson: PropTypes.bool,
    isRemovingControllingPerson: PropTypes.bool,
    targetWhsLinkAccount: PropTypes.shape(),
    isLinkToImyStructureConfirmModalShown: PropTypes.bool,
    isLinkingToImyStructureModalShown: PropTypes.bool,
  };

  static defaultProps = {
    permissions: null,
    storeAccount: {
      name: '',
      customers: [],
      forms: [],
      rc518CpForms: []
    },
    accountDataLoadError: null,
    linkedImyStructure: null,
    isDeleteFormModalShown: false,
    isDeletingForm: false,
    deleteFormError: null,
    isUnlinkFormModalShown: false,
    isUnlinkingForm: false,
    unlinkFormError: null,
    isOwnershipModalShown: false,
    changeOwnershipItem: null,
    defaultWhdCustomerId: 0,
    isUpdateDualFormStatusModalShown: false,
    isUpdatingDualFormStatus: false,
    updateDualFormStatusError: null,
    dualFormCheckStatus: false,
    dualFormSelectedAccountId: 0,
    dualFormSeletedAccountNumber: '',
    isEditingAccountName: false,
    isEditingAccountType: false,
    isEditingAccountDueDiligence: false,
    isEditingAccountCpEquityInterest: false,
    isSubmittingAccount: false,
    controllingPersons: null,
    isGettingControllingPersons: false,
    isExpiringControllingPerson: false,
    isRemovingControllingPerson: false,
    targetWhsLinkAccount: null,
    isLinkToImyStructureConfirmModalShown: false,
    isLinkingToImyStructureModalShown: false
  };

  static getForeignTin(tin, notRequired) {
    if (!tin) {
      return notRequired ? <i>FTIN Declared as Not Legally Required</i> : 'N/A';
    }
    const cleanedTin = tin.replace(/\s/g, '').toLowerCase();
    if (cleanedTin.includes('notlegallyrequired')) {
      return !notRequired ? <React.Fragment>{ tin } (<i>FTIN Not Correctly Declared as Legally Required</i>)</React.Fragment> : <i>FTIN Declared as Not Legally Required</i>;
    }

    return notRequired ? <i>FTIN Declared as Not Legally Required</i> : tin;
  }

  constructor(props) {
    super(props);

    const { storeAccount } = props;

    this.state = {
      isUnlinkCustomerModalShown: false,
      isUnlinkingCustomer: false,
      UnlinkCustomerError: null,
      accountId: null,
      formToDelete: null,
      formToUnlink: null,
      accountName: storeAccount?.accountName ?? null,
      accountType: storeAccount?.financialAccountType ?? null,
      accountDueDiligence: storeAccount?.dueDiligenceProcedure ?? null,
      accountCpEquityInterest: storeAccount?.controllingPersonEquityInterestFlag ?? null,
      isUnlinkCpModalShown: false,
      UnlinkCpError: null,
      cpToUnlinkId: null,
      cpUnlinkMinDate: null,
      isRemoveCpModalShown: false,
      RemoveCpError: null,
      cpToRemoveId: null
    };
  }

  componentDidMount() {
    const { dispatch, match, permissions } = this.props;
    dispatch(accountDataLoad(match.params.id));
    if (AccessControl.hasPermission(permissions, [ActivityPerms.scannedViewTree])) {
      dispatch(getAccountLinkedImyStructure(match.params.id));
    }
    if (AccessControl.hasPermission(permissions, [ActivityPerms.accountEdit, ActivityPerms.accountPageView])) {
      dispatch(getAllControllingPersons(match.params.id));
    }
  }

  componentDidUpdate(prevProps) {
    const { storeAccount } = this.props;

    const rc518Enums = [15, 40];

    const rc518FormsOnAccount = storeAccount?.forms
      ? storeAccount.forms.filter(form => rc518Enums.includes(form.formTypeEnum) && form.workflowStage === 100 && form.isValid === true)
      : [];
    const prevRc518FormsOnAccount = prevProps.storeAccount?.forms
      ? prevProps.storeAccount.forms.filter(form => rc518Enums.includes(form.formTypeEnum) && form.workflowStage === 100 && form.isValid === true)
      : [];

    if (rc518FormsOnAccount.length > 0
      && JSON.stringify(prevRc518FormsOnAccount) !== JSON.stringify(rc518FormsOnAccount)) {
      this.getCpElectedRc518Forms(rc518FormsOnAccount);
    }

    if (JSON.stringify(storeAccount?.rc518CpForms) !== JSON.stringify(prevProps.storeAccount?.rc518CpForms)) {
      this.accountContainsValidCpRelatedForms();
    }
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(clearAccountData());
    dispatch(cancelEditAccountName());
    dispatch(cancelEditAccountType());
    dispatch(cancelEditAccountDueDiligence());
    dispatch(cancelEditAccountCpEquityInterest());
    dispatch(clearAccountLinkedImyStructure());
  }

  onAccountNameChange(e) {
    this.setState({ accountName: e.target.value });
  }

  onUpdateAccountNameCancel(e) {
    const { dispatch, storeAccount } = this.props;
    dispatch(cancelEditAccountName());
    this.setState({ accountName: storeAccount?.accountName });
  }

  onUpdateAccountNameSubmit(e) {
    const { dispatch, storeAccount } = this.props;
    const { accountName } = this.state;
    dispatch(updateAccountName(storeAccount.id, accountName));
  }

  onEditAccountNameClick() {
    const { dispatch, storeAccount } = this.props;
    dispatch(editAccountName());
    this.setState({ accountName: storeAccount.accountName });
  }

  onAccountTypeChange(e) {
    this.setState({ accountType: e.target.value });
  }

  onUpdateAccountTypeCancel() {
    const { dispatch, storeAccount } = this.props;
    dispatch(cancelEditAccountType());
    this.setState({ accountType: storeAccount?.financialAccountType });
  }

  onUpdateAccountTypeSubmit() {
    const { dispatch, storeAccount } = this.props;
    const { accountType } = this.state;
    dispatch(updateAccountType(storeAccount.id, accountType));
  }

  onEditAccountTypeClick() {
    const { dispatch, storeAccount } = this.props;
    dispatch(editAccountType());
    this.setState({ accountType: storeAccount.financialAccountType });
  }

  onAccountDueDiligenceChange(e) {
    this.setState({ accountDueDiligence: e.target.value });
  }

  onUpdateAccountDueDiligenceCancel() {
    const { dispatch, storeAccount } = this.props;
    dispatch(cancelEditAccountDueDiligence());
    this.setState({ accountDueDiligence: storeAccount?.dueDiligenceProcedure });
  }

  onUpdateAccountDueDiligenceSubmit() {
    const { dispatch, storeAccount } = this.props;
    const { accountDueDiligence } = this.state;
    dispatch(updateAccountDueDiligence(storeAccount.id, accountDueDiligence));
  }

  onEditAccountDueDiligenceClick() {
    const { dispatch, storeAccount } = this.props;
    dispatch(editAccountDueDiligence());
    this.setState({ accountDueDiligence: storeAccount.dueDiligenceProcedure });
  }

  onAccountCpEquityInterestChange(e) {
    this.setState({ accountCpEquityInterest: e.target.value });
  }

  onUpdateAccountCpEquityInterestCancel() {
    const { dispatch, storeAccount } = this.props;
    dispatch(cancelEditAccountCpEquityInterest());
    this.setState({ accountCpEquityInterest: storeAccount?.controllingPersonEquityInterestFlag });
  }

  onUpdateAccountCpEquityInterestSubmit() {
    const { dispatch, storeAccount } = this.props;
    const { accountCpEquityInterest } = this.state;
    dispatch(updateAccountCpEquityInterest(storeAccount.id, accountCpEquityInterest));
  }

  onEditAccountCpEquityInterestClick() {
    const { dispatch, storeAccount } = this.props;
    dispatch(editAccountCpEquityInterest());
    this.setState({ accountCpEquityInterest: storeAccount.controllingPersonEquityInterestFlag });
  }

  getAccountName = () => {
    const { storeAccount } = this.props;

    if (storeAccount === null || (!storeAccount.accountNumber && !storeAccount.accountName)) {
      return 'N/A';
    }

    let accountName = storeAccount.accountNumber;

    if (!accountName) {
      accountName = storeAccount.accountName;
    } else if (storeAccount.accountName !== null && storeAccount.accountName !== accountName) {
      accountName = `${ accountName } - ${ storeAccount.accountName }`;
    }

    return accountName;
  };

  // eslint-disable-next-line class-methods-use-this
  getCustomerDescription = (customer) => {
    if (!customer || (!customer.customerId && !customer.name)) {
      return 'N/A';
    }
    let description = customer.customerId;

    if (!description && customer.name) {
      description = customer.name;
    } else if (customer.name) {
      description = `${ description } - ${ customer.name }`;
    }

    return description;
  };

  getCpElectedRc518Forms(rc518FormsOnAccount) {
    const { dispatch, match } = this.props;

    if (match.params.id && rc518FormsOnAccount?.length > 0) {
      dispatch(getRc518CpForms(rc518FormsOnAccount.map(form => form.id), match.params.id));
    }
  }

  openUnlinkFormModal = (formId) => {
    const { dispatch } = this.props;
    this.setState({ formToUnlink: formId });
    dispatch(showUnlinkFormModal());
  };

  closeUnlinkFormModal = () => {
    const { dispatch } = this.props;
    this.setState({ formToUnlink: null });
    dispatch(hideUnlinkFormModal());
  };

  confirmUnlinkForm = () => {
    const { formToUnlink } = this.state;
    const { dispatch, storeAccount } = this.props;
    dispatch(accountFormUnlink(storeAccount.id, formToUnlink));
  };

  openDeleteFormModal = (item) => {
    const { dispatch } = this.props;
    this.setState({ formToDelete: item });
    dispatch(showDeleteFormModal([item]));
  };

  closeDeleteFormModal = () => {
    const { dispatch } = this.props;
    this.setState({ formToDelete: null });
    dispatch(hideDeleteFormModal());
  };

  processDeleteForms = () => {
    const { dispatch, match, permissions } = this.props;
    const { formToDelete } = this.state;
    dispatch(deleteForms([formToDelete.id], () => {
      this.closeDeleteFormModal();
      dispatch(accountDataLoad(match.params.id));
      if (AccessControl.hasPermission(permissions, [ActivityPerms.scannedViewTree])) {
        dispatch(getParentImyForms(null, match.params.id));
      }
      if (AccessControl.hasPermission(permissions, [ActivityPerms.accountEdit, ActivityPerms.accountPageView])) {
        dispatch(getAllControllingPersons(match.params.id));
      }
    }));
  };

  openDualFormStatusModal = (e, accountId, accountNumber) => {
    const { dispatch } = this.props;
    const isActivated = e.target.value === 'required';
    dispatch(showUpdateDualFormStatusModal(isActivated, accountId, accountNumber));
  };

  closeUpdateDualFormStatusModal = () => {
    const { dispatch } = this.props;
    dispatch(hideUpdateDualFormStatusModal());
  };

  processUpdateDualFormStatus = () => {
    const { dispatch, dualFormCheckStatus, dualFormSelectedAccountId } = this.props;
    dispatch(updateDualFormStatus(dualFormCheckStatus, dualFormSelectedAccountId));
  };

  openUnlinkCustomerModal = (accountId) => {
    this.setState({ isUnlinkCustomerModalShown: true, accountId });
  };

  closeUnlinkCustomerModal = () => {
    this.setState({ isUnlinkCustomerModalShown: false });
  };

  confirmUnlinkCustomer = () => {
    const { accountId } = this.state;
    this.processCustomerUnlink(accountId);
    this.setState({ isUnlinkCustomerModalShown: false });
  };

  openUnlinkCpModal = (cpToUnlinkId, cpUnlinkMinDate) => {
    this.setState({ isUnlinkCpModalShown: true, cpToUnlinkId, cpUnlinkMinDate });
  };

  closeUnlinkCpModal = () => {
    this.setState({ isUnlinkCpModalShown: false });
  };

  confirmUnlinkCp = (effectiveDate) => {
    const { cpToUnlinkId } = this.state;
    this.processCpUnlink(cpToUnlinkId, effectiveDate);
    this.setState({ isUnlinkCpModalShown: false });
  };

  openRemoveCpModal = (cpToRemoveId) => {
    this.setState({ isRemoveCpModalShown: true, cpToRemoveId });
  };

  closeRemoveCpModal = () => {
    this.setState({ isRemoveCpModalShown: false });
  };

  confirmRemoveCp = () => {
    const { cpToRemoveId } = this.state;
    this.processCpRemove(cpToRemoveId);
    this.setState({ isRemoveCpModalShown: false });
  };

  closeFromOwnershipModal = (item) => {
    const { dispatch } = this.props;
    dispatch(hideOwnershipModal(item));
  };

  reAssignItem = () => {
    const { dispatch, changeOwnershipItem } = this.props;
    if (changeOwnershipItem != null && changeOwnershipItem.id != null) {
      dispatch(takeQueueItem('form', changeOwnershipItem.id, changeOwnershipItem.accountId));
      dispatch(hideOwnershipModal());
    }
  };

  continueFromOwnershipModal = () => {
    const { dispatch, changeOwnershipItem } = this.props;
    dispatch(hideOwnershipModal());
    let redirectUrl = `/forms/${ changeOwnershipItem.formType.toLowerCase() }/${ changeOwnershipItem.id }`;
    if (changeOwnershipItem.accountId) {
      redirectUrl = `${ redirectUrl }?account=${ changeOwnershipItem.accountId }`;
    }
    dispatch(push(redirectUrl));
  };

  closeLinkToImyStructureConfirmModal = () => {
    const { dispatch } = this.props;
    dispatch(hideLinkToImyStructureConfirmModal());
  };

  openLinkToImyStructureConfirmModal(targetWhsLinkAccount) {
    const { dispatch } = this.props;
    dispatch(showLinkToImyStructureConfirmModal(targetWhsLinkAccount));
  }

  openAccountNumberChangeModal() {
    const { dispatch } = this.props;
    dispatch(showAccountNumberChangeModal());
  }

  closeAccountNumberChangeModal() {
    const { dispatch } = this.props;
    dispatch(hideAccountNumberChangeModal());
  }

  processAccountNumberChange(updatedAccount) {
    const { dispatch } = this.props;
    dispatch(processAccountNumberChange(updatedAccount));
  }

  processCustomerLink(addedAccountData) {
    const { dispatch, storeAccount } = this.props;
    dispatch(accountCustomerLink(storeAccount.id, addedAccountData));
    dispatch(reset('addAccountCustomerForm'));
    dispatch(change('addAccountCustomerForm', 'customerId', null));
  }

  processCustomerUnlink(customerId) {
    const { dispatch, storeAccount } = this.props;
    dispatch(accountCustomerUnlink(storeAccount.id, customerId));
  }

  processCpUnlink(cpToUnlinkId, effectiveDate) {
    const { dispatch, storeAccount } = this.props;
    dispatch(expireControllingPerson(cpToUnlinkId, storeAccount.id, effectiveDate));
  }

  processCpRemove(cpToRemoveId) {
    const { dispatch, storeAccount } = this.props;
    dispatch(removeControllingPerson(cpToRemoveId, storeAccount.id));
  }

  accountContainsValidCpRelatedForms() {
    const { storeAccount } = this.props;
    const crseEnums = [5, 22, 24];
    const crsCpEnums = [7, 21, 23];
    const rc519Enums = [14, 39];
    const rc518Enums = [15, 40];

    const crseFormsOnAccount = storeAccount?.forms
      ? storeAccount.forms.filter(form => crseEnums.includes(form.formTypeEnum) && form.workflowStage === 100 && form.isValid === true)
      : [];
    const crsCpFormsOnAccount = storeAccount?.forms
      ? storeAccount.forms.filter(form => crsCpEnums.includes(form.formTypeEnum) && form.workflowStage === 100 && form.isValid === true)
      : [];

    const rc519FormsOnAccount = storeAccount?.forms
      ? storeAccount.forms.filter(form => rc519Enums.includes(form.formTypeEnum) && form.workflowStage === 100 && form.isValid === true)
      : [];

    const crsCpLinkedForms = storeAccount?.linkedCustomerForms
      ? storeAccount.linkedCustomerForms.filter(form => crsCpEnums.includes(form.formTypeEnum)) // already checked as valid & WFC in DB Query
      : [];

    const rc518LinkedForms = storeAccount?.linkedCustomerForms
      ? storeAccount.linkedCustomerForms.filter(form => rc518Enums.includes(form.formTypeEnum)) // already checked as valid & WFC in DB Query
      : [];

    if ((crseFormsOnAccount.length > 0 && (crsCpFormsOnAccount.length > 0 || crsCpLinkedForms.length > 0))
      || (rc519FormsOnAccount.length > 0 && (storeAccount?.rc518CpForms?.length > 0 || rc518LinkedForms.length > 0))) {
      return true;
    }
    return false;
  }

  confirmLinkToImyStructure(accountIdToLinkTo) {
    const { dispatch, storeAccount } = this.props;
    dispatch(linkAccountToImyStructure(storeAccount.id, accountIdToLinkTo));
  }

  render() {
    const { permissions, storeAccount, isLoadingData, settings, accountDataLoadError, isAccountNumberChangeModalShown, linkedImyStructure, dispatch,
      isDeleteFormModalShown, isDeletingForm, deleteFormError, isUnlinkFormModalShown, isUnlinkingForm, unlinkFormError,
      isOwnershipModalShown, changeOwnershipItem, defaultWhdCustomerId,
      isUpdateDualFormStatusModalShown, isUpdatingDualFormStatus, updateDualFormStatusError, dualFormCheckStatus, dualFormSeletedAccountNumber,
      isEditingAccountName, isEditingAccountType, isEditingAccountDueDiligence, isEditingAccountCpEquityInterest, isSubmittingAccount, controllingPersons,
      isGettingControllingPersons, isExpiringControllingPerson, isRemovingControllingPerson, targetWhsLinkAccount, isLinkToImyStructureConfirmModalShown,
      isLinkingToImyStructureModalShown
    } = this.props;
    const {
      isUnlinkCustomerModalShown,
      isUnlinkingCustomer,
      UnlinkCustomerError,
      formToDelete,
      accountName,
      accountType,
      accountDueDiligence,
      accountCpEquityInterest,
      isUnlinkCpModalShown,
      UnlinkCpError,
      isRemoveCpModalShown,
      RemoveCpError,
      cpUnlinkMinDate
    } = this.state;

    const singleCustomer = storeAccount && storeAccount.customers && storeAccount.customers.length === 1 && storeAccount.customers[0];
    const addressPopulated = singleCustomer?.address && (singleCustomer.address.line1 || singleCustomer.address.line2 || singleCustomer.address.postalCode || singleCustomer.address.country);
    const showWithholding = storeAccount && settings && settings.showWithholding && AccessControl.hasPermission(permissions, [ActivityPerms.whdViewRates]);

    let certData = null;
    if (singleCustomer) {
      certData = singleCustomer.formCertificationData ?? singleCustomer.importCertificationData;
    }
    return (
      <div className="container account-page-panel">

        { accountDataLoadError && (accountDataLoadError.code !== 0
          && <NotFoundPage caption={ accountDataLoadError.message } />
        ) }

        { !accountDataLoadError && (isLoadingData || storeAccount == null) && <LoadingWrapper loaded={ !isLoadingData && storeAccount !== null } />}
        {!accountDataLoadError && !isLoadingData && storeAccount !== null && <div className="account-panel" id="account-page-panel-wrapper">
          <div className="panel" id="account-page-account-details-panel">
            <div className="panel-header">
              <div className="panel-title" id="account-page-title">
                Account: { this.getAccountName() }
                <ActiveChip isActive={ storeAccount?.isActive } />
                <DirectChip isDirect={ storeAccount?.isDirect } />
              </div>
              {storeAccount?.isDirect && <AccessControl allowedPermissions={ [ActivityPerms.accountEdit] }>
                <button type="submit" className="btn btn-primary" onClick={ () => this.openAccountNumberChangeModal() }>
                  Change Account Number
                </button>
              </AccessControl>}
            </div>
            <div className="panel-body">
              { storeAccount && <div className="no-shrink">
                <div className="panel-body-caption">
                  <h2 id="account-page-account-details-name"><strong>Account Details:</strong></h2>
                </div>
                <div className="columns">
                  <div className="col-4 col-xl-5 col-md-6">
                    <div className="columns">
                      <div className="col-5 panel-item-name">
                        <p id="account-page-certification-status-name"><strong>Certification Status: </strong></p>
                      </div>
                      <div className="col-7 panel-item-value">
                        <p id="account-page-certification-status-value">{ storeAccount && getCertifictionStatus(storeAccount.certificationStatus) }</p>
                      </div>
                      <div className="col-5 panel-item-name">
                        <p id="account-page-account-name-name"><strong>Name: </strong></p>
                      </div>
                      <div className="col-7 panel-item-value">
                        {!isEditingAccountName && <p className="account-name" id="account-page-account-name-value">
                          { storeAccount && storeAccount.accountName ? storeAccount.accountName : 'N/A' }
                        </p> }
                        { !isEditingAccountName && AccessControl.hasPermission(permissions, [ActivityPerms.accountEdit]) && storeAccount?.isDirect === true && <button
                          type="button"
                          className="btn btn-link"
                          onClick={ () => this.onEditAccountNameClick() }
                        >
                          <i className="icon icon-edit" id="account-page-change-account-name-button" />
                        </button> }
                        { isEditingAccountName && AccessControl.hasPermission(permissions, [ActivityPerms.accountEdit]) && <React.Fragment>
                          <input
                            className="form-input"
                            maxLength="200"
                            disabled={ isSubmittingAccount }
                            value={ accountName ?? '' }
                            onChange={ e => this.onAccountNameChange(e) }
                            id="account-page-change-account-name-value"
                          />
                          <button
                            type="button"
                            className="btn btn-link editing"
                            disabled={ isSubmittingAccount }
                            onClick={ () => this.onUpdateAccountNameSubmit() }
                          ><i className="icon icon-check" id="account-page-change-account-name-submit" /></button>
                          <button
                            type="button"
                            className="btn btn-link editing"
                            disabled={ isSubmittingAccount }
                            onClick={ () => this.onUpdateAccountNameCancel() }
                          ><i className="icon icon-cross" id="account-page-change-account-name-cancel" /></button>
                        </React.Fragment> }
                      </div>
                      { singleCustomer && <React.Fragment>
                        <div className="col-5 panel-item-name">
                          <p id="account-page-customer-name"><strong>Customer: </strong></p>
                        </div>
                        <div className="col-7 panel-item-value"><p id="account-page-customer-value">{ this.getCustomerDescription(singleCustomer) }</p></div>
                      </React.Fragment> }
                      { (settings.showDualForms || storeAccount.isDualFormRequired !== null)
                        && storeAccount && (storeAccount.legalEntity && storeAccount.legalEntity.dualFormRequirement > 0)
                        && <React.Fragment>
                          <div className="col-5 panel-item-name">
                            <p id="account-page-dual-form-status-name"><strong>Dual Form Status: </strong></p>
                          </div>
                          <div className="col-7 panel-item-value dual-form">
                            <label className="form-checkbox option">
                              <input
                                type="radio"
                                name="dualFormStatus"
                                checked={ storeAccount.isDualFormRequired === null }
                                disabled
                              />
                              <i className="form-icon" id="account-page-dual-form-autodetect-checkbox" />
                              <span className="option-label" id="account-page-dual-form-autodetect-checkbox-name">
                                Auto Detect</span>
                            </label>
                            <label className="form-checkbox option">
                              <input
                                type="radio"
                                name="dualFormStatus"
                                value="required"
                                checked={ storeAccount.isDualFormRequired === true }
                                disabled={ !settings.showDualForms || storeAccount.isDualFormSatisfied === true }
                                onChange={ e => this.openDualFormStatusModal(e, storeAccount.id, storeAccount.accountNumber) }
                              />
                              <i className="form-icon" id="account-page-dual-form-required-checkbox" />
                              <span className="option-label" id="account-page-dual-form-required-checkbox-name">
                                Required
                              </span>
                            </label>
                            <label className="form-checkbox option">
                              <input
                                type="radio"
                                name="dualFormStatus"
                                value="notRequired"
                                checked={ storeAccount.isDualFormRequired === false }
                                disabled={ !settings.showDualForms || storeAccount.isDualFormSatisfied === true }
                                onChange={ e => this.openDualFormStatusModal(e, storeAccount.id, storeAccount.accountNumber) }
                              />
                              <i className="form-icon" id="account-page-dual-form-not-required-checkbox" />
                              <span className="option-label" id="account-page-dual-form-not-required-checkbox-name">
                                Not Required
                              </span>
                            </label>
                          </div>
                        </React.Fragment> }
                    </div>
                  </div>
                  <div className="col-4 col-xl-5 col-md-6">
                    <div className="columns">
                      <div className="col-5 panel-item-name">
                        <p id="account-page-joint-account-name"><strong>Joint Account: </strong></p>
                      </div>
                      <div className="col-7 panel-item-value"><p id="account-page-joint-account-value">{ storeAccount.isJointAccount ? 'Yes' : 'No' }</p></div>
                      <div className="col-5 panel-item-name">
                        <p id="account-page-account-type-name"><strong>Account Type: </strong></p>
                      </div>
                      <div className="col-7 panel-item-value">
                        {!isEditingAccountType && <p className="account-type" id="account-page-account-type-value">
                          { storeAccount && storeAccount.financialAccountType ? FinancialAccountTypes.getDescription(storeAccount.financialAccountType) : 'Not Reported' }
                        </p> }
                        { !isEditingAccountType && AccessControl.hasPermission(permissions, [ActivityPerms.accountEdit]) && storeAccount?.isDirect === true && <button
                          type="button"
                          className="btn btn-link"
                          onClick={ () => this.onEditAccountTypeClick() }
                        >
                          <i className="icon icon-edit" id="account-page-change-account-type-button" />
                        </button> }
                        { isEditingAccountType && AccessControl.hasPermission(permissions, [ActivityPerms.accountEdit]) && <React.Fragment>
                          <select
                            id="dropdown-account-type"
                            className="dropdown-account-type form-select"
                            onChange={ e => this.onAccountTypeChange(e) }
                            disabled={ isSubmittingAccount }
                            value={ accountType ?? '0' }
                          >
                            <option value="0">Not Reported</option>
                            <option value="1">Depository</option>
                            <option value="2">Custodial</option>
                            <option value="3">Cash Value Insurance Or Annuity Contract</option>
                            <option value="4">Equity And Debt Interests</option>
                          </select>
                          <button
                            type="button"
                            className="btn btn-link editing"
                            disabled={ isSubmittingAccount }
                            onClick={ () => this.onUpdateAccountTypeSubmit() }
                          ><i className="icon icon-check" id="account-page-change-account-type-submit" /></button>
                          <button
                            type="button"
                            className="btn btn-link editing"
                            disabled={ isSubmittingAccount }
                            onClick={ () => this.onUpdateAccountTypeCancel() }
                          ><i className="icon icon-cross" id="account-page-change-account-type-cancel" /></button>
                        </React.Fragment> }
                      </div>
                      <div className="col-5 panel-item-name">
                        <p id="account-page-due-diligence-name"><strong>Due Diligence: </strong></p>
                      </div>
                      <div className="col-7 panel-item-value">
                        {!isEditingAccountDueDiligence && <p className="account-due-diligence" id="account-page-account-due-diligence-value">
                          { storeAccount && storeAccount.dueDiligenceProcedure ? DueDiligenceProcedures.getDescription(storeAccount.dueDiligenceProcedure) : 'Not Reported' }
                        </p> }
                        { !isEditingAccountDueDiligence && AccessControl.hasPermission(permissions, [ActivityPerms.accountEdit]) && storeAccount?.isDirect === true && <button
                          type="button"
                          className="btn btn-link"
                          onClick={ () => this.onEditAccountDueDiligenceClick() }
                        >
                          <i className="icon icon-edit" id="account-page-change-account-due-diligence-button" />
                        </button> }
                        { isEditingAccountDueDiligence && AccessControl.hasPermission(permissions, [ActivityPerms.accountEdit]) && <React.Fragment>
                          <select
                            id="dropdown-account-due-diligence"
                            className="dropdown-account-due-diligence form-select"
                            onChange={ e => this.onAccountDueDiligenceChange(e) }
                            disabled={ isSubmittingAccount }
                            value={ accountDueDiligence ?? '0' }
                          >
                            <option value="0">Not Reported</option>
                            <option value="1">New Account</option>
                            <option value="2">Preexisting Account</option>
                          </select>
                          <button
                            type="button"
                            className="btn btn-link editing"
                            disabled={ isSubmittingAccount }
                            onClick={ () => this.onUpdateAccountDueDiligenceSubmit() }
                          ><i className="icon icon-check" id="account-page-change-account-due-diligence-submit" /></button>
                          <button
                            type="button"
                            className="btn btn-link editing"
                            disabled={ isSubmittingAccount }
                            onClick={ () => this.onUpdateAccountDueDiligenceCancel() }
                          ><i className="icon icon-cross" id="account-page-change-account-due-diligence-cancel" /></button>
                        </React.Fragment> }
                      </div>
                      <div className="col-5 panel-item-name">
                        <p id="account-page-joint-account-cp-equity-interest"><strong>Controlling Person Equity Interest: </strong></p>
                      </div>
                      <div className="col-7 panel-item-value">
                        {!isEditingAccountCpEquityInterest && <p className="account-cp-equity-interest" id="account-page-account-cp-equity-interest-value">
                          { storeAccount?.controllingPersonEquityInterestFlag === true ? 'Yes' : 'No' }
                        </p> }
                        { !isEditingAccountCpEquityInterest && AccessControl.hasPermission(permissions, [ActivityPerms.accountEdit]) && storeAccount?.isDirect === true && <button
                          type="button"
                          className="btn btn-link"
                          onClick={ () => this.onEditAccountCpEquityInterestClick() }
                        >
                          <i className="icon icon-edit" id="account-page-change-account-cp-equity-interest-button" />
                        </button> }
                        { isEditingAccountCpEquityInterest && AccessControl.hasPermission(permissions, [ActivityPerms.accountEdit]) && <React.Fragment>
                          <select
                            id="dropdown-account-cp-equity-interest"
                            className="dropdown-account-cp-equity-interest form-select"
                            onChange={ e => this.onAccountCpEquityInterestChange(e) }
                            disabled={ isSubmittingAccount }
                            value={ accountCpEquityInterest ?? 'false' }
                          >
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                          </select>
                          <button
                            type="button"
                            className="btn btn-link editing"
                            disabled={ isSubmittingAccount }
                            onClick={ () => this.onUpdateAccountCpEquityInterestSubmit() }
                          ><i className="icon icon-check" id="account-page-change-account-cp-equity-interest-submit" /></button>
                          <button
                            type="button"
                            className="btn btn-link editing"
                            disabled={ isSubmittingAccount }
                            onClick={ () => this.onUpdateAccountCpEquityInterestCancel() }
                          ><i className="icon icon-cross" id="account-page-change-account-cp-equity-interest-cancel" /></button>
                        </React.Fragment> }
                      </div>
                      { singleCustomer && <React.Fragment>
                        <div className="col-5 panel-item-name">
                          <p id="account-page-permanent-address-name"><strong>Permanent Address: </strong></p>
                        </div>
                        <div className="col-7 panel-item-value">
                          { addressPopulated && <React.Fragment>
                            <span id="account-page-permanent-address-line1">{singleCustomer.address.line1 !== null ? singleCustomer.address.line1 : ''}</span>
                            <span id="account-page-permanent-address-line2">{singleCustomer.address.line2 !== null ? singleCustomer.address.line2 : ''}</span>
                            <span id="account-page-permanent-address-line3">{singleCustomer.address.line3 !== null ? singleCustomer.address.line3 : ''}</span>
                            <span id="account-page-permanent-address-line4">{singleCustomer.address.line4 !== null ? singleCustomer.address.line4 : ''}</span>
                            <span id="account-page-permanent-address-postcode">{singleCustomer.address.postalCode !== null ? singleCustomer.address.postalCode : ''}</span>
                            <span id="account-page-permanent-address-country">{singleCustomer.address.country !== null ? singleCustomer.address.country : ''}</span>
                          </React.Fragment> }
                          { !addressPopulated && <p>N/A</p> }
                        </div>
                      </React.Fragment> }
                    </div>
                  </div>
                  <div className="col-4 col-xl-5 col-md-6">
                    { storeAccount != null && storeAccount.customers != null && storeAccount.customers.length === 1
                      && <div className="columns">
                        <div className="col-5 panel-item-name">
                          <p id="account-page-treaty-country-name"><strong>Treaty Country: </strong></p>
                        </div>
                        <div className="col-7 panel-item-value">
                          <p id="account-page-treaty-country-value">{certData?.treatyCountry ? certData.treatyCountry : 'N/A'}</p>
                        </div>
                        { certData?.lobCategoryCode && certData.lobCategoryCode !== '' && <React.Fragment>
                          <div className="col-5 panel-item-name">
                            <p id="account-page-lob-name"><strong>LOB: </strong></p>
                          </div>
                          <div className="col-7 panel-item-value">
                            <p id="account-page-lob-value">{certData?.lobCategoryCode ? certData.lobCategoryCode : 'N/A'}</p>
                          </div>
                        </React.Fragment> }
                        <div className="col-5 panel-item-name">
                          <p id="account-page-us-tin-name"><strong>U.S. TIN: </strong></p>
                        </div>
                        <div className="col-7 panel-item-value"><p id="account-page-us-tin-value">{certData?.tin ? certData.tin : 'N/A'}</p></div>
                        <div className="col-5 panel-item-name">
                          <p id="account-page-ftin-name"><strong>Foreign TIN: </strong></p>
                        </div>
                        <div className="col-7 panel-item-value">
                          <p id="account-page-ftin-value">
                            { Account.getForeignTin(certData?.foreignTin, certData?.foreignTinNotRequired) }
                          </p></div>
                        <div className="col-5 panel-item-name">
                          <p id="account-page-giin-name"><strong>GIIN: </strong></p>
                        </div>
                        <div className="col-7 panel-item-value"><p id="account-page-giin-value">{certData?.giin ? certData.giin : 'N/A'}</p></div>
                        <div className="col-5 panel-item-name">
                          <p id="account-page-part-2-giin-name"><strong>Part 2 GIIN: </strong></p>
                        </div>
                        <div className="col-7 panel-item-value"><p id="account-page-part-2-giin-value">{certData?.part2Giin ? certData.part2Giin : 'N/A'}</p></div>
                      </div> }
                    { storeAccount != null && storeAccount.customers != null && storeAccount.customers.length > 1
                        && <span className="toast toast-info m-0 text-center" id="account-page-multiple-accounts-name">
                          Navigate to the Customer Page for each account holder<br />to view additional certification data points
                        </span> }
                  </div>
                </div>
                { storeAccount && !storeAccount.isActive && storeAccount.activeStatusDate && moment(storeAccount.activeStatusDate).isBefore(moment().subtract(90, 'days'))
                  && <div className="columns">
                    <div className="col-12">multiple=a
                      <span className="toast toast-info m-0 text-center" id="account-page-inactive-account-name">
                        This account has been inactive for over 90 days. All details will no longer be updated.
                      </span>
                    </div>
                  </div> }
              </div> }
              { storeAccount.legalEntity && <div className="no-shrink">
                <div className="panel-body-caption">
                  <h2 id="account-page-legal-entity-details-name"><strong>Legal Entity Details:</strong></h2>
                </div>
                <div className="columns">
                  <div className="col-4 col-xl-5 col-md-6">
                    <div className="columns">
                      <div className="col-5 panel-item-name">
                        <p id="account-page-legal-entity-name"><strong>Legal Entity: </strong></p>
                      </div>
                      <div className="col-7 panel-item-value">
                        <p id="account-page-legal-entity-value">
                          {`${ storeAccount.legalEntity.name } (${ storeAccount.legalEntity.identifier ? storeAccount.legalEntity.identifier : 'N/A' })`}
                        </p>
                      </div>
                      <div className="col-5 panel-item-name">
                        <p id="account-page-us-tax-obligation-name"><strong>Legal Entity has US Tax Obligation?: </strong></p>
                      </div>
                      <div className="col-7 panel-item-value">
                        {storeAccount.legalEntity?.usTaxObligation !== null && <p id="account-page-us-tax-obligation-value">{ storeAccount.legalEntity.usTaxObligation ? 'Yes' : 'No' }</p> }
                        {storeAccount.legalEntity?.usTaxObligation === null && <p id="account-page-us-tax-obligation-value">N/A</p> }
                      </div>
                      <div className="col-5 panel-item-name">
                        <p id="account-page-crs-participating-name"><strong>CRS Participating?: </strong></p>
                      </div>
                      <div className="col-7 panel-item-value">
                        { storeAccount.legalEntity?.crsParticipating !== null && <p id="account-page-crs-participating-value">{ storeAccount.legalEntity.crsParticipating ? 'Yes' : 'No' }</p> }
                        {storeAccount.legalEntity?.crsParticipating === null && <p id="account-page-crs-participating-value">N/A</p> }
                      </div>
                    </div>
                  </div>
                  <div className="col-4 col-xl-5 col-md-6">
                    <div className="columns">
                      <div className="col-5 panel-item-name">
                        <p id="account-page-chapter-3-name"><strong>Chapter 3: </strong></p>
                      </div>
                      <div className="col-7 panel-item-value" id="account-page-chapter-3-value">
                        { storeAccount.legalEntity?.chapter3Status !== null ? storeAccount.legalEntity?.chapter3StatusDescription : 'N/A' }
                      </div>
                      <div className="col-5 panel-item-name">
                        <p id="account-page-chapter-4-name"><strong>Chapter 4: </strong></p>
                      </div>
                      <div className="col-7 panel-item-value" id="account-page-chapter-4-value">
                        { storeAccount.legalEntity?.chapter4Status !== null ? storeAccount.legalEntity?.chapter4StatusDescription : 'N/A' }
                      </div>
                    </div>
                  </div>
                </div>
              </div> }
              <AccountNumberChangeModal
                id={ storeAccount.id }
                accountNumber={ storeAccount.accountNumber }
                isShown={ isAccountNumberChangeModalShown }
                onConfirm={ updatedAccount => this.processAccountNumberChange(updatedAccount) }
                onCancel={ () => this.closeAccountNumberChangeModal() }
              />
            </div>
          </div>
          <div className="panel" id="account-page-linked-forms-panel">
            <div className="panel-body">
              <div className="panel-body-caption no-shrink">
                <h2 id="account-page-linked-forms-name"><strong>Forms Linked to Account: </strong></h2>
              </div>
              <div className="no-shrink">
                <AccountFormList
                  permissions={ permissions }
                  account={ storeAccount }
                  onDeleteForm={ item => this.openDeleteFormModal(item) }
                  onConfirmFormUnlink={ accountId => this.openUnlinkFormModal(accountId) }
                />
              </div>
              { storeAccount?.forms && storeAccount.forms.length > 0 && <div className="no-shrink columns">
                <div className="col-6 col-sm-12">
                  { AccessControl.hasPermission(permissions, [ActivityPerms.scannedEdit]) && <MoveForm
                    title="Move Form"
                    introText="Moving a form removes it from the current account and associates it with the target account and customer.
                      The form will be automatically identified as pending initial review and require revalidation. You cannot move workflow complete forms."
                    sourceAccountId={ storeAccount.id }
                    forms={ storeAccount.forms.filter(f => f.workflowStage !== 100) } // Only Non-Workflow Complete Forms
                    onSuccess={ () => dispatch(accountDataLoad(storeAccount.id)) }
                  /> }
                </div>
                <div className="col-6 col-sm-12">
                  { AccessControl.hasPermission(permissions, [ActivityPerms.scannedEdit]) && <CloneForm
                    title="Clone Form"
                    introText="Cloning a form creates and associates a new copy of the form on the target account.&nbsp;
                        Where the legal entity set up differs between accounts, the form will be automatically identified as pending initial review and will require validation."
                    sourceAccountId={ storeAccount.id }
                    forms={ storeAccount.forms }
                  /> }
                </div>
              </div> }
            </div>
          </div>
          <div className="panel" id="account-page-customers-panel">
            <div className="panel-body">
              <div className="panel-body-caption no-shrink">
                <h2 id="account-page-linked-customers-name"><strong>Customers Linked to Account: </strong></h2>
              </div>
              <div className="no-shrink">
                <AccountCustomerList
                  account={ storeAccount }
                  defaultWhdCustomerId={ defaultWhdCustomerId }
                  jointAccountsEnabled={ settings.showJointAccounts }
                  onConfirmCustomerUnlink={ accountId => this.openUnlinkCustomerModal(accountId) }
                  permissions={ permissions }
                />
              </div>
              { settings.showJointAccounts && <AccessControl allowedPermissions={ [ActivityPerms.accountEdit] }>
                <div className="panel-body-caption no-shrink">
                  <h2 id="account-page-link-customer-name"><strong>Link a Customer: </strong></h2>
                </div>
                <div className="col-8">
                  <AddAccountCustomerForm onConfirmCustomerLink={ updateData => this.processCustomerLink(updateData) } />
                </div>
              </AccessControl> }
            </div>
          </div>
          <div className="panel" id="account-page-controlling-persons-panel">
            <div className="panel-body">
              <div className="panel-body-caption no-shrink">
                <h2 id="account-page-linked-cps"><strong>Controlling Persons Linked to Account: </strong></h2>
              </div>
              <div className="no-shrink">
                <AccountControllingPersonsList
                  controllingPersons={ controllingPersons }
                  isGettingControllingPersons={ isGettingControllingPersons }
                  forms={ [...(storeAccount.forms ?? []), ...(storeAccount.linkedCustomerForms ?? [])] }
                  onConfirmCpUnlink={ (id, minDate) => this.openUnlinkCpModal(id, minDate) }
                  onConfirmCpRemove={ id => this.openRemoveCpModal(id) }
                  accountIsActive={ storeAccount && storeAccount.isActive }
                />
              </div>
              {this.accountContainsValidCpRelatedForms()
              && <AccessControl allowedPermissions={ [ActivityPerms.accountEdit] }>
                <div className="col-8">
                  <AddAccountControllingPerson
                    title="Link Controlling Person:"
                    sourceAccountId={ storeAccount.id }
                    forms={ storeAccount.forms }
                    linkedForms={ storeAccount.linkedCustomerForms }
                    accountIsActive={ storeAccount && storeAccount.isActive }
                  />
                </div>
              </AccessControl>}
            </div>
          </div>
          {AccessControl.hasPermission(permissions, [ActivityPerms.accountLinkWhs]) && !linkedImyStructure
            && <div className="panel" id="account-page-link-imy-tree-panel">
              <div className="panel-body link-imy">
                <div className="panel-body-caption">
                  <h2 id="account-page-link-imy-structures-name"><strong>Link IMY Tree Structure: </strong></h2>
                </div>
                <div>
                  <UnlinkedImyStructure storeAccount={ storeAccount } onConfirmImyStructureLink={ updateData => this.openLinkToImyStructureConfirmModal(updateData) } />
                </div>
              </div>
            </div>}
          {linkedImyStructure && <div className="panel" id="account-page-imy-trees-panel">
            <div className="panel-body">
              <div className="panel-body-caption">
                <h2 id="account-page-linked-imy-structures-name"><strong>Linked IMY Tree Structure: </strong></h2>
              </div>
              <div>
                <LinkedImyStructure structure={ linkedImyStructure } permissions={ permissions } />
              </div>
            </div>
          </div> }
          <div className="panel" id="account-page-comments-panel">
            <div className="panel-body">
              <AccountComments accountId={ storeAccount.id } />
            </div>
          </div>
          <div className="panel" id="account-page-whd-rates-panel">
            <div className="panel-body">
              { showWithholding && AccessControl.hasPermission(permissions, [ActivityPerms.whdViewRates]) && <div>
                <div className="panel-body-caption no-shrink">
                  <h2 id="account-page-whd-rates-name"><strong>Withholding Rates: </strong></h2>
                </div>
                <div>
                  <WithholdingRates showAccountName={ false } accountId={ storeAccount.id } />
                </div>
              </div> }
            </div>
          </div>
        </div> }
        <ConfirmModal
          key="unlinkForm"
          isShown={ isUnlinkFormModalShown }
          isPerformingAction={ isUnlinkingForm }
          onConfirm={ () => this.confirmUnlinkForm() }
          onCancel={ () => this.closeUnlinkFormModal() }
          error={ unlinkFormError }
          title="Unlink"
          message="Are you sure you want to unlink this form?"
        />
        <ConfirmModal
          key="UnlinkCustomer"
          isShown={ isUnlinkCustomerModalShown }
          isPerformingAction={ isUnlinkingCustomer }
          onConfirm={ () => this.confirmUnlinkCustomer() }
          onCancel={ () => this.closeUnlinkCustomerModal() }
          error={ UnlinkCustomerError }
          title="Unlink"
          message="Are you sure you want to unlink this customer?"
        />
        <ControllingPersonUnlinkModal
          key="UnlinkCp"
          isShown={ isUnlinkCpModalShown }
          isPerformingAction={ isExpiringControllingPerson }
          onConfirm={ effectiveDate => this.confirmUnlinkCp(effectiveDate) }
          onCancel={ () => this.closeUnlinkCpModal() }
          minDate={ cpUnlinkMinDate }
          error={ UnlinkCpError }
          title="Unlink"
          message="Are you sure you want to unlink this controlling person?"
        />
        <DeleteFormModal
          isShown={ isDeleteFormModalShown }
          isDeletingForm={ isDeletingForm }
          onConfirmDelete={ () => this.processDeleteForms() }
          onCancel={ () => this.closeDeleteFormModal() }
          deleteFormError={ deleteFormError }
          items={ formToDelete !== null ? [formToDelete] : [] }
        />
        <UpdateDualFormStatusModal
          isShown={ isUpdateDualFormStatusModalShown }
          isUpdatingDualFormStatus={ isUpdatingDualFormStatus }
          onConfirmUpdate={ () => this.processUpdateDualFormStatus() }
          onCancel={ () => this.closeUpdateDualFormStatusModal() }
          updateDualFormStatusError={ updateDualFormStatusError }
          checkStatus={ dualFormCheckStatus }
          accountNumber={ dualFormSeletedAccountNumber }
        />
        <ConfirmModal
          key="RemoveCp"
          isShown={ isRemoveCpModalShown }
          isPerformingAction={ isRemovingControllingPerson }
          onConfirm={ () => this.confirmRemoveCp() }
          onCancel={ () => this.closeRemoveCpModal() }
          error={ RemoveCpError }
          title="Remove"
          message="Are you sure you want to permanently remove this record?"
          confirmTitle="Yes"
          cancelTitle="No"
        />
        { changeOwnershipItem != null && <ChangeOwnershipModal
          isShown={ isOwnershipModalShown }
          onAssign={ () => this.reAssignItem() }
          onContinueWithoutAssign={ () => this.continueFromOwnershipModal() }
          onCancel={ () => this.closeFromOwnershipModal() }
          workflowRecord={ changeOwnershipItem }
        /> }
        <ConfirmModal
          key="LinkWhsAccountConfirm"
          isShown={ isLinkToImyStructureConfirmModalShown }
          onConfirm={ () => this.confirmLinkToImyStructure(targetWhsLinkAccount.id) }
          onCancel={ () => this.closeLinkToImyStructureConfirmModal() }
          title="Link Account"
          message={ <span>Are you sure you want to <strong>permanently</strong> link this IMY structure?`</span> }
          confirmTitle="Yes"
          cancelTitle="No"
        />
        { targetWhsLinkAccount && targetWhsLinkAccount.id && targetWhsLinkAccount.id > 0 && isLinkingToImyStructureModalShown
          && <LinkWhsAccountModal
            key="LinkWhsAccount"
            isShown={ isLinkingToImyStructureModalShown }
            accountId={ targetWhsLinkAccount.id }
            reloadOnComplete
          />}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    auth: {
      permissions,
      settings
    },
    account: {
      storeAccount,
      isLoadingData,
      accountDataLoadError,
      isUnlinkFormModalShown,
      isUnlinkingForm,
      unlinkFormError,
      isAccountNumberChangeModalShown,
      isUpdateDualFormStatusModalShown,
      isUpdatingDualFormStatus,
      updateDualFormStatusError,
      dualFormCheckStatus,
      dualFormSelectedAccountId,
      dualFormSeletedAccountNumber,
      isEditingAccountName,
      isEditingAccountType,
      isEditingAccountDueDiligence,
      isEditingAccountCpEquityInterest,
      isSubmittingAccount,
      controllingPersons,
      isGettingControllingPersons,
      targetWhsLinkAccount,
      isLinkToImyStructureConfirmModalShown,
      isLinkingToImyStructureModalShown,
      linkedImyStructure
    },
    forms: {
      isGettingParentImyForms,
      parentImyForms,
      isDeleteFormModalShown,
      isDeletingForm,
      deleteFormError
    },
    workflow: {
      isOwnershipModalShown,
      changeOwnershipItem
    },
    withholding: {
      accountWithholdingRates
    }
  } = state;

  const defaultWhdCustomerContainer = accountWithholdingRates && accountWithholdingRates.find(x => x && x.defaultRatesCustomerId > 0 && x.rates && x.rates.length > 0);
  const defaultWhdCustomerId = defaultWhdCustomerContainer && defaultWhdCustomerContainer.defaultRatesCustomerId;

  return {
    permissions,
    storeAccount,
    settings,
    isLoadingData,
    accountDataLoadError,
    isGettingParentImyForms,
    parentImyForms,
    isDeleteFormModalShown,
    isDeletingForm,
    deleteFormError,
    isUnlinkFormModalShown,
    isUnlinkingForm,
    unlinkFormError,
    isAccountNumberChangeModalShown,
    isOwnershipModalShown,
    changeOwnershipItem,
    defaultWhdCustomerId,
    isUpdateDualFormStatusModalShown,
    isUpdatingDualFormStatus,
    updateDualFormStatusError,
    dualFormCheckStatus,
    dualFormSelectedAccountId,
    dualFormSeletedAccountNumber,
    isEditingAccountName,
    isEditingAccountType,
    isEditingAccountDueDiligence,
    isEditingAccountCpEquityInterest,
    isSubmittingAccount,
    controllingPersons,
    isGettingControllingPersons,
    targetWhsLinkAccount,
    isLinkToImyStructureConfirmModalShown,
    isLinkingToImyStructureModalShown,
    linkedImyStructure,
    rc518CpForms: storeAccount?.rc518CpForms ?? []
  };
}

const mapDispatchToProps = dispatch => ({ dispatch });

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(withContainerErrorBoundary(Account, 'Account')));
